export default "__VITE_ASSET__o5PevGaCqWe6v5EiRsSaNQ__"